import type { PropertyData } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { useFormContext } from "react-hook-form";
import { DropdownField } from "../../form/DropdownField";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { useSetSearchInputAtom } from "../search/searchInputAtom";
import { emptyLocationDropdownItem } from "./constants";
import { useSetStatesCitiesAtom } from "./statesCitiesAtom";

interface Props {
    error?: string;
}

export const CountryDropdown: FunctionComponent<Props> = ({ error }) => {
    const { countriesList } = useStaticDataAtomValue();
    const setStatesCitiesAtom = useSetStatesCitiesAtom();
    const setSearchInput = useSetSearchInputAtom();
    const { setValue: setFormValue } = useFormContext<PropertyData>();
    const {
        cmsData: {
            location: { countryRegion, pleaseEnterCountry },
        },
    } = useStaticDataAtomValue();

    const handleCountryChange = () => {
        setSearchInput("");
        setFormValue("state", emptyLocationDropdownItem);
        setFormValue("city", emptyLocationDropdownItem);
        setFormValue("streetAddress", "");
        setStatesCitiesAtom({
            states: [],
            cities: [],
        });
    };

    return (
        <DropdownField
            label={countryRegion}
            field="country"
            items={countriesList}
            onChange={handleCountryChange}
            error={error}
            rules={{
                validate: {
                    notEmpty: (v) => (v !== null && v.id !== 0) || pleaseEnterCountry,
                },
            }}
            dataElementName="country-region"
        />
    );
};
